export default __webpack_public_path__ + "static/media/home-menu.c8aac59d.svg";